import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import ICONS from "../../../../../assets/Icons";
import { beneSuccessDetail } from "../../../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import { ownerListViewAllAcc } from "../../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import accountNameStandardised from "../../../../../utils/accountNamestandardised";
import CommonToast from "../../../../_utils/CommonToast";
import { formatAccountNumber } from "../../../../_utils/FormatAccountNumber";
import DataActionField from "../../../../_utils/TransactionCommonComponents/DataActionField";

const BeneficiaryRecreateTxnStepSourceDestination = ({
  activeStep,
  beneCat,
  beneName,
  OwnerAcctName,
  txnPayload,
  setSourceSelect,
  isConfidential,
  setIsConfidential,
  beneTxnAccountData,
  setMapingData,
  setMapingCat,
  accountSelect,
  setAccountSelect,
  setIsAutoFilledSource,
  isAutoFilledSource,
  setCatSelect,
  categories,
  category,
  selectedCategory,
}) => {
  const dispatch = useDispatch();
  const hasFetchedRef = useRef(false);

  const beneficiaryId =
    beneTxnAccountData?.transaction?.[0]?.beneficiary_account_id;

  const normalize = (str) => str?.trim().toLowerCase();

  const assignedCategories = category || [];

  const sourceAccountNoPrevious =
    beneTxnAccountData?.transaction?.[0]?.owner_account_bank_acc_no;

  const matchedCategory = categories?.find(
    (cat) => normalize(cat?.name) === normalize(beneCat),
  );

  const isAssigned = assignedCategories?.some(
    (cat) => normalize(cat) === normalize(beneCat),
  );

  const isCategoryAvailable = matchedCategory && isAssigned;

  const txn = beneTxnAccountData?.transaction?.[0];

  const sourceAccNo = txn?.owner_account_bank_acc_no;

  const config =
    beneTxnAccountData?.transaction?.[0]?.confidential_transaction !== "N";

  useEffect(() => {
    if (OwnerAcctName) {
      dispatch(ownerListViewAllAcc({ bank_account_no: OwnerAcctName }));
    }
    if (beneficiaryId) {
      dispatch(beneSuccessDetail(beneficiaryId));
    }
    hasFetchedRef.current = true;
  }, [activeStep, OwnerAcctName, beneficiaryId, dispatch]);

  return (
    <>
      <div className="mt-[80px] Qmd:mt-margin-md w-full mb-margin-md">
        <div className="flex flex-col Qmd:flex-row gap-gap-xl px-padding-md Qmd:px-padding-base">
          <DataActionField
            label="Source Account"
            value={formatAccountNumber(sourceAccNo)}
            isActive={isAutoFilledSource}
            icon={
              txnPayload?.ownerBankAccountNo === sourceAccountNoPrevious
                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                : ICONS?.AUTOFILL_WHITE
            }
            onClick={() => {
              setIsAutoFilledSource(true);
              setSourceSelect(true);
              setMapingData("renderSource");
            }}
            hoverEnabled={
              txnPayload?.ownerBankAccountNo !== sourceAccountNoPrevious
            }
          />
          <DataActionField
            label="Destination Account"
            value={accountNameStandardised(beneName?.toLowerCase())}
            isActive={accountSelect}
            disabled={!txnPayload?.ownerBankAccountNo}
            icon={
              accountSelect
                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                : ICONS?.AUTOFILL_WHITE
            }
            onClick={() => {
              if (!txnPayload?.ownerBankAccountNo) return;

              const approvalStatus =
                beneTxnAccountData?.transaction?.[0]
                  ?.beneficiary_account_approval_status;
              if (
                approvalStatus !== "approved" &&
                approvalStatus !== "pending"
              ) {
                CommonToast({
                  text: "Unable to find destination account.",
                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                  variant: "var(--error)",
                  buttonNeeded: false,
                });
                return;
              }
              setAccountSelect(true);
              setMapingData("renderData");
            }}
            hoverEnabled={accountSelect === false}
          />
        </div>

        <div className="flex flex-col Qmd:flex-row gap-gap-xl mt-margin-md px-padding-md Qmd:px-padding-base">
          <DataActionField
            label="Create As Confidential Transaction"
            value={
              beneTxnAccountData?.transaction?.[0]?.confidential_transaction ===
              "Y"
                ? "Confidential transaction enabled"
                : "Confidential transaction disabled"
            }
            isActive={isConfidential === config}
            icon={
              isConfidential === config
                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                : ICONS?.AUTOFILL_WHITE
            }
            onClick={() => {
              if (
                beneTxnAccountData?.transaction?.[0]
                  ?.confidential_transaction === "Y"
              ) {
                setIsConfidential(true);
              } else {
                setIsConfidential(false);
              }
            }}
            hoverEnabled={isConfidential !== config}
          />
          <DataActionField
            label="Select Transaction Category"
            value={beneCat}
            disabled={
              !txnPayload?.bankAccountNo ||
              !beneTxnAccountData?.transaction?.[0]
                ?.beneficiary_account_bank_acc_no
            }
            isActive={!!txnPayload?.selectedCategory}
            icon={
              beneCat === selectedCategory?.name
                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                : ICONS?.AUTOFILL_WHITE
            }
            onClick={() => {
              if (!isCategoryAvailable) {
                CommonToast({
                  text: "Category no longer exists.",
                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                  variant: "var(--error)",
                  buttonNeeded: false,
                });
                return;
              }

              setMapingCat("renderCat");
              setCatSelect(true);
            }}
            hoverEnabled={beneCat !== selectedCategory?.name}
          />
        </div>
      </div>
    </>
  );
};

export default BeneficiaryRecreateTxnStepSourceDestination;
